import { AppStateInterface } from '../state/app.state';
import { createSelector } from '@ngrx/store';
import { EventVariablesStoreInterface } from '../models/event-variables-store.interface';

export const selectEventVariables = (state: AppStateInterface) => state.eventVariables;

export const canFastActivateSubscriptionSelector = createSelector(
  selectEventVariables,
  (state: EventVariablesStoreInterface) => state.cancellationFlowIsActive,
);

export const cancellationFlowIsActiveSelector = createSelector(
  selectEventVariables,
  (state: EventVariablesStoreInterface) => state.canFastActivateSubscription,
);

export const isFreeUserRegisteredSelector = createSelector(
  selectEventVariables,
  (state: EventVariablesStoreInterface) => state.isFreeUserRegistered,
);

export const isComplianceUserSelector = createSelector(
  selectEventVariables,
  (state: EventVariablesStoreInterface) => state.isUserCompliance,
);

export const isProfilePage = createSelector(
  selectEventVariables,
  (state: EventVariablesStoreInterface) => state.isProfilePage,
);
export const isCoinsPackTest = createSelector(
  selectEventVariables,
  (state: EventVariablesStoreInterface) => state.isCoinsPackTest,
);
